import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px) and hide when near the bottom offer section
      const scrollY = window.scrollY;
      const offerSection = document.getElementById('oferta');
      let offerTop = Infinity;
      if (offerSection) {
        offerTop = offerSection.offsetTop - window.innerHeight;
      }
      if (scrollY > 600 && scrollY < offerTop) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-131">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 w-full z-50 p-4 md:hidden" data-id="element-132">
          <div className="bg-white/90 backdrop-blur-md p-4 rounded-2xl shadow-[0_-10px_40px_rgba(0,0,0,0.1)] border border-brand-brown/10 flex items-center justify-between" data-id="element-133">
            <div className="flex-1 mr-4" data-id="element-134">
              <p className="text-xs font-bold text-brand-brown uppercase tracking-wider mb-0.5" data-id="element-135">
                El Protocolo
              </p>
              <p className="text-sm font-medium text-brand-text leading-tight" data-id="element-136">
                Sueño en 7 Minutos
              </p>
            </div>
            <button onClick={scrollToOffer} className="bg-brand-brown text-white text-sm font-bold py-3 px-6 rounded-xl shadow-md active:scale-95 transition-transform" data-id="element-137">
              ¡LO QUIERO!
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}